import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaTelegramPlane } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function Footer() {
  return (
    <div className="Footer">
      <div className="container">
        <div className="social_icons mb-3 d-flex justify-content-center align-items-center gap-3">
       
           <a href="https://x.com/ipproject2025" target="_blank" >
          <div className="indi_icons">
           
              <FaXTwitter className="" />
          
          </div>
          </a>
          <a href="https://t.me/ippp2025"  target="_blank" >
          <div className="indi_icons">

              <FaTelegramPlane className="" />
           
          </div>
          </a>
        </div>
        <p className="text-white fw-bold text-center mb-0">
          Copyright@2025 : IP Token all rights reserved
        </p>
        <p className="text-white fw-bold text-center mb-0">
        <a href="mailto:support@ip2025.biz">Email: support@ip2025.biz</a>
       </p>
      </div>
    </div>
  );
}
